import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, getFormValues, Field } from 'redux-form';
import compose from 'lodash/fp/compose';
import { withTranslation } from 'react-i18next';
import i18n from 'i18next';

import { fetchUsers, getListErrors, REDUCER_NAME } from 'src/reducers/users/roleUsers';
import { getSelectOptions } from 'src/reducers/selectOptions';

import BreadCrumb from 'jbc-front/components/BreadCrumb';
import { SearchEmploymentStatusField } from 'jbc-front/components/SearchForm';

import { CLIENT_SETTINGS } from 'src/constants/EndpointUrls';
import SearchDetector from 'src/components/SearchDetector';
import SearchFormPaginator from 'src/components/SearchFormPaginator';
import DetailSearchForm from 'src/components/DetailSearchForm';
import {
  FORM_NAME_ROLE_USERS_SEARCH,
  takeClientRoleUsersResetFormQueries,
  fetchClientRoles,
  takeClientRoleUsersSearchQueriesFromLocation,
  takeClientRoleUsersSearchQueries
} from 'src/reducers/searchForm';
import { convertArrayIntoJbcStyle } from 'src/utils/Utils';
import { DUMMY_ID_CLIENT_ROLE_ALL } from 'src/utils/fieldConverters';

import EditableList from './containers/EditableList';
import EditableListButtons from './containers/EditableListButtons';
import Invite from './containers/Invite';
import FormErrors from '../../components/FormErrors';
import styles from './RoleUsersList.scss';

class RoleUsersList extends React.Component {
  componentWillMount() {
    const { dispatch } = this.props;
    dispatch(fetchClientRoles());
  }

  // 権限フィルタのid, nameの配列を取得する
  static getRoleButtonValues(clientRoles) {
    // サーバーから取得する権限には「すべて」は含まれないためフロント制御用の選択項目として独自で追加する
    return [{ id: DUMMY_ID_CLIENT_ROLE_ALL, name: i18n.t('constants.Options.EmploymentStatus.all') }, ...convertArrayIntoJbcStyle(clientRoles)];
  }

  render() {
    const { initialValues: formValues, location, resetValues, dispatch, clientRoles, errors } = this.props;
    return (
      <div>
        <SearchDetector
          location={location}
          didMountDetectingJudger={() => true}
          willReceivePropsDetectingJudger={(prevProps, nextProps) => nextProps.location !== prevProps.location}
          onDetect={() => {
            dispatch(fetchUsers(takeClientRoleUsersSearchQueries(formValues)));
          }}
        />
        <div className="l-main-title-wrap">
          <h1 className="m-title-main">{this.props.t('features.RoleUsers.RoleUsersList.authority_management_setting')}</h1>
          <p className="m-title-main-note">
            {this.props.t(
              'features.RoleUsers.RoleUsersList.operation_staff_do_not_have_the_operation_authority_over_My_Number_and_authority_management_setting'
            )}
          </p>
        </div>
        <div className="l-wrap-xl l-contents-wrap">
          <div>
            <BreadCrumb>
              <BreadCrumb.Item label={this.props.t('components.SideMenu.SideMenu.setting')} path={CLIENT_SETTINGS} />
              <BreadCrumb.Item label={this.props.t('features.RoleUsers.RoleUsersList.authority_management_setting')} />
            </BreadCrumb>
          </div>
          <FormErrors errors={errors} />
          <div className={styles.menuButtons}>
            <Invite />
          </div>

          <DetailSearchForm
            containAccountTypes
            containEmployeeEnrollmentStatus
            containsOtherSearch={false}
            formName={FORM_NAME_ROLE_USERS_SEARCH}
            resetValues={resetValues}
            menuRender={() => (
              <Field
                name="clientRoles"
                component={SearchEmploymentStatusField}
                employmentStatuses={RoleUsersList.getRoleButtonValues(clientRoles)}
                onEmploymentStatusChange={() => {}}
              />
            )}
          />
          <div className={styles.wrap}>
            <EditableListButtons />
            <div className={styles.paginator}>
              <SearchFormPaginator formName={FORM_NAME_ROLE_USERS_SEARCH} reducerName={REDUCER_NAME} noPaginator />
            </div>
          </div>
          <div className="l-overflow-scroll u-mt10">
            <EditableList />
          </div>
          <SearchFormPaginator formName={FORM_NAME_ROLE_USERS_SEARCH} reducerName={REDUCER_NAME} noLimit />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  initialValues: {
    ...takeClientRoleUsersSearchQueriesFromLocation(state.router.location),
    ...getFormValues(FORM_NAME_ROLE_USERS_SEARCH)(state)
  },
  resetValues: takeClientRoleUsersResetFormQueries(state, true),
  location: state.router.location,
  clientRoles: getSelectOptions(state, 'clientRoles'),
  errors: getListErrors(state)
});

export default withTranslation('translation')(
  compose(
    connect(mapStateToProps),
    reduxForm({
      form: FORM_NAME_ROLE_USERS_SEARCH,
      enableReinitialize: true
    })
  )(RoleUsersList)
);
